<template>
  
    <!-- <div style="display: flex; justify-content: space-between; height: 50px; width: 100%; background-color: white; position: sticky; top: 0px; z-index: 10;">
        <div>
          <div style=" font-size: 13px; font-weight: 500;">AI matches your requests with top listings. Adjust the matching rate to fit your needs.</div>  
          <div style="margin-bottom: 10px; font-size: 13px; font-weight: 500;">Selected Requests with {{ selectionLimit }}% Match</div>
          <Slider v-model="selectionLimit" :min="70" style="width: 200px;"/>
        </div>
        <TButton
            label="Send Quotations"
            color="primary-color"
            @click="createBulkQuotations()"
            style="margin-left: 25px"
        />
    </div> -->

    <t-datatable
    :dataKey="'matchingKits'"
    :actions="{get: ''}"
    :hideSearch="true"
    :scrollable="false"
    ref="matching_kits"
    :showCheckboxes=false
    :emptyData="{
      show: true,
      showButton:false,
      imgSrc: $config.noListings,
      message: 'There are no requests yet...',
    }"
    :config="{
      columns: [
      { title: 'Id',keys: ['id'],custom: viewId,click: goToProductDetails},
      { title: 'Date', keys: ['created_at'], style: 'width:70px;', custom:showDate},
      { title: 'Title', Keys: ['rfp_content', 'title'], custom: title,click: goToProductDetails, },
      { title: 'Category', Keys: ['rfp_content', 'title'], custom: displayCategory,click: goToProductDetails, },
      { title: 'Budget', keys: ['rfp_content', 'budget'], custom: budgetDisplay,   },
      { title: 'Match Score (%)', keys: ['score'], custom: (data)=>{ return Math.round(data.score*10000)/100}},
      ],
    }"
  ></t-datatable>

    
  </template>
  
  <script>
  import GeneralHelper from "../../helpers/GeneralHelper";
  import store from "../../../store";
  import { CREATE_QUOTATION, GET_MATCHING_KITS } from "../../../domains/rfp/store/actions";
  import TDatatable from "../datatable/TDatatable.vue";
  import TButton from "../buttons/TButton.vue";
  import translation from "../../../translations";
  import { SHOW_TOAST_MESSAGE } from "../../store/actions";
  import Slider from 'primevue/slider';

  export default {
    created() {},
    components: {
      TDatatable,
      // TButton,
      // Slider,
    },
    props:{
        rfpId: {
            type: Number,
            default: null
        }
    },    
    data() {
      return {
        selection: [],
        selectionLimit: localStorage.getItem('rfp_matching_selection_limit')||90
      };
    },
    async mounted() {
        console.log(this.rfpId)
        await this.$store.dispatch(GET_MATCHING_KITS, this.rfpId)
        this.selection = this.$store.getters.matchingKits.filter((x)=>x.score>this.selectionLimit/100)
    },
    watch: {
        rfpId: {
            async handler(newValue) {
                console.log(this.rfpId)
                await this.$store.dispatch(GET_MATCHING_KITS, this.rfpId)
                this.selection = this.$store.getters.matchingKits.filter((x)=>x.score>this.selectionLimit/100)
            },
            deep: true,
        },
        selectionLimit: {
            async handler(newValue) {
              this.selection = this.$store.getters.matchingKits.filter((x)=>x.score>this.selectionLimit/100)
              localStorage.setItem('rfp_matching_selection_limit', this.selectionLimit)    
            },
            deep: true,
        },
  },
  
    methods: {
      checkbox(data){
        console.log(this.selection.some(e => e.id == data.id))
        return (
          `<input type='checkbox' ${this.selection.some(e => e.id == data.id)?"checked":''}>`
        );
      },
      async createBulkQuotations()
      {
        let requests = []
        let number_of_quotations = this.selection.length
        for (let i =0; i < this.selection.length; i++)
        {
          requests.push(this.$store.dispatch(CREATE_QUOTATION, {
            rfp_id: this.selection[i].id,
            customer_id: this.$store.getters.customer.id,
            kit_id: this.rfpId,
          }));
  
        }

        await Promise.all(requests)
        await this.$store.dispatch(GET_MATCHING_KITS, this.rfpId)
        this.selection = this.$store.getters.matchingKits.filter((x)=>x.score>this.selectionLimit)
        this.$store.dispatch(SHOW_TOAST_MESSAGE, GeneralHelper.buildMessage(1, `${number_of_quotations} Offers Sent Successfully`))
      },
      clickCheckbox(data)
      {
        const index = this.selection.indexOf(data);
        if (index > -1) { // only splice array when item is found
          this.selection.splice(index, 1); // 2nd parameter means remove one item only
        }
        else{
          this.selection.push(data)
        }
        console.log(this.selection)
      },
      url(data)
      {
        let kit = {
          id : data.id,
          brandName : data.brandName,
          categoryName : data.categoryName,
          title : data.title
        }
        let url = GeneralHelper.kitLink(kit)

        return url
      },
      async goToProductDetails(data){
    
        let url = this.url(data)
        window.location = url 
        
      },
      
    },
  
    setup() {
  
      const eraseCookie = (name) => {
        document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
      };
  
      const displayCategory = (data) => {
        if (data.categoryName) {
            var s =
            "<span style='cursor:pointer; font-weight:600; text-decoration: underline;'>" +
            translation(data.categoryName);
        } else {
            var s = "";
        }
        return s;
      };

      const displayProduct = (data) => {
        if (data.productName) {
            var s =
            "<span style='cursor:pointer; font-weight:600; text-decoration: underline;'>" +
            translation(data.productName);
        } else {
            var s = "";
        }
        return s;
      };

      
  
      const showDate = (data)=>{
        const dateString = data.createdAt;
        const date = new Date(dateString);
        const formattedDate = date.toISOString().split('T')[0];
        return "<span>"+ formattedDate + "</span>"
      }
  
      const title = (data) => {
        return "<span style='cursor:pointer; font-weight:600; text-decoration: underline;'>" +translation(data.title)
      };
      const openRfpDetails = (data) => {
        store.dispatch("toggleRfpDetailsDialog", data);
      };
  
      const statusDisplay = (data) => {  
        return data.availabilityName;
      };
  
      const quantityDisplay = (data) => {
        return data.quantity;
      };
  
      const viewId = (data) => {
        return (
          "<span style='cursor:pointer;'>#" + GeneralHelper.pad(data.id, 5) + "</span>"
        );
      };
  
  
      const viewIdMob = (data) => {
        return GeneralHelper.pad(data.id, 5);
      };
      const viewKit = () => {
        return "<span style='cursor:pointer; color:blue'>View Item</span>";
      };
  
      const openKit = (data) => {
        store.dispatch("displayProductDetails1", {option: true, id: data.id});
      };
  
      const quote = (data) => {
        store.dispatch(SWITCH_SELL_FORM);
        store.commit(SELL_SET_RFP_ID, data);
      };
      const datepostedDisplay = (data) => {
        return data.created_at.split("T")[0];
      };
  
      const deadlineDisplay = (data) => {
        return data.dead + " days";
      };
      const offerRangeDisplay = (data) => {
        var min = data.minOffer == null ? "" : data.minOffer;
        var max = data.maxOffer == null ? "" : data.maxOffer;
        return (
          data.rfp_content.currency.symbo +
          " " +
          GeneralHelper.formatPice(min) +
          " - " +
          data.rfp_content.currency.symbo +
          " " +
          GeneralHelper.formatPice(max)
        );
      };
  
      const budgetDisplay = (data) => {
        return (
          store.getters.currency.symbol +
          GeneralHelper.formatPice(data.cprice)
        );
      };
  
      return {
        displayCategory,
        openRfpDetails,
        statusDisplay,
        quantityDisplay,
        viewKit,
        budgetDisplay,
        offerRangeDisplay,
        deadlineDisplay,
        datepostedDisplay,
        quote,
        openKit,
        viewIdMob,
        viewId,
        showDate,
        title,
        displayProduct
      };
    },
  
    computed: {
      currency() {
        return this.$store.getters.currency;
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  
  </style>
  